module.exports = __webpack_public_path__ + "static/media/iesalud-grey.05ea0c69.svg";